module.exports = __webpack_public_path__ + "e3de166437bd8de50be894e205acccfe.svg";